(function (scope) {
  'use strict';
  var GAMES = ['all', 'magic', 'yugioh', 'one-piece', 'pokemon', 'dragon-ball-super', 'flesh-and-blood', 'digimon', 'other'];
  var SORTS = ['recommended', 'price-asc', 'price-desc', 'discount-desc', 'release-asc', 'release-desc', 'title-asc', 'title-desc'];
  var AVAILABILITY = ['all', 'available', 'sold-out'];
  var DEFAULTS = { game: 'all', type: 'all', availability: 'all', sort: 'recommended', query: '', min: '', max: '', language: 'all' };

  function readState(href) {
    var params = new URL(href).searchParams;
    return {
      game: GAMES.indexOf(params.get('game')) >= 0 ? params.get('game') : 'all',
      type: params.get('type') || 'all', query: params.get('query') || '', min: params.get('min') || '', max: params.get('max') || '', language: params.get('language') || 'all',
      availability: AVAILABILITY.indexOf(params.get('availability')) >= 0 ? params.get('availability') : 'all',
      sort: SORTS.indexOf(params.get('sort')) >= 0 ? params.get('sort') : 'recommended'
    };
  }

  function stateUrl(href, state) {
    var url = new URL(href);
    Object.keys(DEFAULTS).forEach(function (key) {
      if (state[key] && state[key] !== DEFAULTS[key]) url.searchParams.set(key, state[key]);
      else url.searchParams.delete(key);
    });
    // Client controls cover the full collection, never a native filtered page.
    ['page', 'view', 'sort_by'].forEach(function (key) { url.searchParams.delete(key); });
    return url.pathname + url.search + url.hash;
  }

  function matches(card, state) {
    return (!state.query || state.query.toLocaleLowerCase().trim().split(/\s+/).every(function (word) { return (card.title || '').toLocaleLowerCase().includes(word); })) &&
      (!state.min || card.price >= Number(state.min) * 100) && (!state.max || card.price <= Number(state.max) * 100) &&
      (!state.language || state.language === 'all' || card.language === state.language) &&
      (state.game === 'all' || card.game === state.game) &&
      (state.type === 'all' || card.type === state.type) &&
      (state.availability === 'all' || card.available === (state.availability === 'available'));
  }

  function ordered(cards, sort) {
    return cards.slice().sort(function (a, b) {
      var difference = 0;
      if (sort === 'title-asc' || sort === 'title-desc') difference = (a.title || '').localeCompare(b.title || '', undefined, { numeric: true, sensitivity: 'base' }) * (sort === 'title-desc' ? -1 : 1);
      if (sort === 'release-asc' || sort === 'release-desc') {
        if (!a.release && b.release) return 1;
        if (a.release && !b.release) return -1;
        difference = (a.release || '').localeCompare(b.release || '') * (sort === 'release-desc' ? -1 : 1);
      }
      if (sort === 'price-asc') difference = a.price - b.price;
      if (sort === 'price-desc') difference = b.price - a.price;
      if (sort === 'discount-desc') difference = b.discount - a.discount || a.price - b.price;
      return difference || a.index - b.index;
    });
  }

  function createController(root, windowObject) {
    var win = windowObject || scope;
    var english = root.dataset.locale === 'en';
    var copy = english ? {
      loading: 'Loading all offers… Filters will be available when loading is complete.',
      error: 'Not all offers could be loaded. The products shown are only a partial list; filters are paused.',
      loaded: ' offers loaded', count: ' offers', of: ' of '
    } : {
      loading: 'Caricamento di tutte le offerte… I filtri saranno disponibili al termine.',
      error: 'Non è stato possibile caricare tutte le offerte. I prodotti visibili sono un elenco parziale; i filtri sono sospesi.',
      loaded: ' offerte caricate', count: ' offerte', of: ' di '
    };
    var form = root.querySelector('[data-offers-controls]');
    var fieldset = form.querySelector('fieldset');
    var fragment = root.querySelector('[data-offers-fragment]');
    var list = fragment.querySelector('[data-offers-items]');
    var count = root.querySelector('[data-offers-count]');
    var notice = root.querySelector('[data-offers-notice]');
    var message = root.querySelector('[data-offers-message]');
    var retry = root.querySelector('[data-offers-retry]');
    var empty = root.querySelector('[data-offers-empty]');
    var base = new URL(root.dataset.collectionUrl, win.location.href);
    var collectionId = fragment.dataset.collectionId;
    var cards = [];
    var seenProducts = new Set();
    var seenCandidates = new Set();
    var variantTasks = new Map();
    var visited = new Set();
    var totalCandidates = Number(fragment.dataset.totalCandidates);
    var totalPages = Math.max(1, Number(fragment.dataset.pages));
    var processed = 0;
    var currentPage = 0;
    var nextUrl = null;
    var complete = false;
    var running = false;
    var restart = false;
    var lastError = null;
    var state = readState(win.location.href);
    var controller = { ready: null, retry: load, getState: function () {
      return { complete: complete, running: running, loaded: cards.length, processed: processed, page: currentPage, lastError: lastError, state: Object.assign({}, state) };
    } };

    function urlFor(page) {
      var url = new URL(base.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set('view', 'offerte-feed');
      url.searchParams.set('page', page);
      return url.href;
    }

    function normalizedNext(href, expectedPage) {
      var url = new URL(href, base.href);
      if (url.origin !== base.origin || url.pathname !== base.pathname || Number(url.searchParams.get('page')) !== expectedPage) throw inconsistent('Invalid continuation');
      return urlFor(expectedPage);
    }

    function inconsistent(text) {
      var error = new Error(text);
      error.restartCollection = true;
      return error;
    }

    function parseCard(node, index) {
      var data = node.dataset;
      var price = Number(data.price);
      var compare = Number(data.comparePrice);
      if (!data.productId || !data.variantId || !(price > 0 && compare > price)) throw inconsistent('Invalid offer variant');
      return { node: node, id: data.productId, game: data.game, type: data.productType,
        title: data.filterTitle || '', release: data.filterRelease || '', language: data.filterLanguage || '',
        variantId: data.variantId, available: data.available === 'true', price: price, discount: (compare - price) * 100 / compare, index: index };
    }

    function consume(source, replace) {
      var page = Number(source.dataset.page);
      var pages = Math.max(1, Number(source.dataset.pages));
      var candidates = Number(source.dataset.candidateCount);
      var total = Number(source.dataset.totalCandidates);
      var expected = replace ? 1 : currentPage + 1;
      if (source.dataset.collectionId !== collectionId || page !== expected || (!replace && visited.has(page)) ||
          !Number.isInteger(candidates) || candidates < 0 || candidates > 48 ||
          !Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages !== Math.max(1, Math.ceil(total / 48)) ||
          (!replace && (total !== totalCandidates || pages !== totalPages))) throw inconsistent('Incomplete collection page');
      var next = source.querySelector('[data-offers-next]');
      if ((page < pages) !== Boolean(next)) throw inconsistent('Missing continuation');
      var proposedNext = next ? normalizedNext(next.getAttribute('href'), page + 1) : null;
      var candidateIds = Array.from(source.querySelectorAll('[data-offers-product-ids] > [data-product-id]')).map(function (node) { return node.dataset.productId; });
      if (candidateIds.length !== candidates || new Set(candidateIds).size !== candidates ||
          candidateIds.some(function (id) { return !id || (!replace && seenCandidates.has(id)); })) throw inconsistent('Duplicate or missing candidate');
      var nodes = Array.from(source.querySelectorAll('[data-offers-items] > [data-offers-card]'));
      var rows = nodes.map(function (node) { return parseCard(node, Number(node.dataset.position)); });
      if (nodes.length > candidates || new Set(rows.map(function (row) { return row.id; })).size !== rows.length ||
          rows.some(function (row) { return candidateIds.indexOf(row.id) < 0 || (!replace && seenProducts.has(row.id)); })) throw inconsistent('Invalid or duplicate offer');
      // Validate first, then commit the whole page so Retry never loses half a page.
      if (replace) {
        list.replaceChildren(); cards = []; seenProducts.clear(); seenCandidates.clear(); variantTasks.clear(); processed = 0;
        visited.clear(); totalCandidates = total; totalPages = pages;
        root.querySelectorAll('[data-offers-variant-source]').forEach(function (node) { node.remove(); });
      }
      candidateIds.forEach(function (id) { seenCandidates.add(id); });
      rows.forEach(function (row) {
        seenProducts.add(row.id); cards.push(row);
        if (row.node.parentElement !== list) { row.node = win.document.importNode(row.node, true); list.appendChild(row.node); }
      });
      source.querySelectorAll('[data-offers-variant-source]').forEach(function (node) {
        if (source !== fragment) { node = win.document.importNode(node, true); fragment.appendChild(node); }
        variantTasks.set(node.dataset.productId, { id: node.dataset.productId, total: Number(node.dataset.variantCount),
          url: node.dataset.productUrl, position: Number(node.dataset.position), node: node, complete: false });
      });
      processed += candidates;
      currentPage = page;
      visited.add(page);
      nextUrl = proposedNext;
      root.querySelectorAll('[data-offers-pagination]').forEach(function (node) { node.hidden = true; });
      count.textContent = cards.length + copy.loaded;
    }

    function fillTypes() {
      var languages = form.elements.namedItem('language');
      while (languages.options.length > 1) languages.remove(1);
      Array.from(new Set(cards.map(function (card) { return card.language; }).filter(Boolean))).sort().forEach(function (value) { var option = win.document.createElement('option'); option.value = value; option.textContent = value; languages.appendChild(option); });
      var select = form.elements.namedItem('type');
      while (select.options.length > 1) select.remove(1);
      var types = Array.from(new Set(cards.map(function (card) { return card.type; }))).sort(function (a, b) { return a.localeCompare(b); });
      if (state.type !== 'all' && types.indexOf(state.type) < 0) types.push(state.type);
      types.forEach(function (type) { var option = win.document.createElement('option'); option.value = type; option.textContent = type; select.appendChild(option); });
    }

    function apply() {
      if (!complete) return;
      var shown = 0;
      ordered(cards, state.sort).forEach(function (card) {
        card.node.hidden = !matches(card, state);
        if (!card.node.hidden) shown += 1;
        list.appendChild(card.node);
      });
      Object.keys(DEFAULTS).forEach(function (key) { form.elements.namedItem(key).value = state[key]; });
      count.textContent = shown === cards.length ? shown + copy.count : shown + copy.of + cards.length + copy.count;
      empty.hidden = shown > 0;
    }

    async function fetchPage(href, selector) {
      var abort = new win.AbortController();
      var timer = win.setTimeout(function () { abort.abort(); }, 20000);
      try {
        var response = await win.fetch(href, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: abort.signal });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        var doc = new win.DOMParser().parseFromString(await response.text(), 'text/html');
        var fragments = doc.querySelectorAll(selector || '[data-offers-fragment]');
        if (fragments.length !== 1) throw new Error('Missing offers response');
        return fragments[0];
      } finally { win.clearTimeout(timer); }
    }

    function betterVariant(candidate, current) {
      return !current || (candidate.available && !current.available) ||
        (candidate.available === current.available && (candidate.discount > current.discount ||
          (candidate.discount === current.discount && (candidate.price < current.price ||
            (candidate.price === current.price && Number(candidate.variantId) < Number(current.variantId))))));
    }

    async function loadVariants(task) {
      var productUrl = new URL(task.url, base.href);
      if (productUrl.origin !== base.origin || !Number.isInteger(task.total) || task.total <= 250) throw inconsistent('Invalid variant source');
      var nextPage = 1;
      var ids = new Set();
      var best = null;
      while (nextPage) {
        var url = new URL(productUrl.href); url.search = ''; url.hash = '';
        url.searchParams.set('view', 'offerte-variants'); url.searchParams.set('page', nextPage);
        var source = await fetchPage(url.href, '[data-offers-variants-fragment]');
        var page = Number(source.dataset.page);
        var pages = Number(source.dataset.pages);
        if (source.dataset.productId !== task.id || page !== nextPage ||
            Number(source.dataset.totalVariants) !== task.total || Number(source.dataset.paginatedItems) !== task.total ||
            pages !== Math.ceil(task.total / 50)) throw inconsistent('Incomplete variant page');
        var pageIds = Array.from(source.querySelectorAll('[data-offers-variant-ids] > [data-variant-id]')).map(function (node) { return node.dataset.variantId; });
        var expectedCount = Math.min(50, task.total - (page - 1) * 50);
        if (pageIds.length !== expectedCount || new Set(pageIds).size !== pageIds.length ||
            pageIds.some(function (id) { return !id || ids.has(id); })) throw inconsistent('Duplicate or missing variants');
        pageIds.forEach(function (id) { ids.add(id); });
        var winners = source.querySelectorAll('[data-offers-items] > [data-offers-card]');
        if (winners.length > 1) throw inconsistent('Ambiguous variant winner');
        if (winners.length) {
          var candidate = parseCard(winners[0], task.position);
          if (candidate.id !== task.id || pageIds.indexOf(candidate.variantId) < 0) throw inconsistent('Winner outside variant page');
          if (betterVariant(candidate, best)) best = candidate;
        }
        var next = source.querySelector('[data-offers-next]');
        if ((page < pages) !== Boolean(next)) throw inconsistent('Missing variant continuation');
        if (next) {
          var nextAddress = new URL(next.getAttribute('href'), productUrl.href);
          if (nextAddress.origin !== productUrl.origin || nextAddress.pathname !== productUrl.pathname || Number(nextAddress.searchParams.get('page')) !== page + 1) throw inconsistent('Invalid variant continuation');
        }
        nextPage = next ? page + 1 : null;
      }
      if (ids.size !== task.total) throw inconsistent('Incomplete variant coverage');
      cards = cards.filter(function (row) { if (row.id !== task.id) return true; row.node.remove(); return false; });
      if (best) { best.node = win.document.importNode(best.node, true); best.node.dataset.position = task.position; list.appendChild(best.node); cards.push(best); }
      task.complete = true; task.node.hidden = true;
      count.textContent = cards.length + copy.loaded;
    }

    async function load() {
      if (running || complete) return;
      running = true; lastError = null; retry.hidden = true; notice.hidden = false;
      fieldset.disabled = true; message.textContent = copy.loading;
      if (win.EnigmaContentFeedback) win.EnigmaContentFeedback.begin(message);
      try {
        if (currentPage === 0) {
          if (!restart && Number(fragment.dataset.page) === 1 && !visited.size) consume(fragment, false);
          else consume(await fetchPage(urlFor(1)), true);
          restart = false;
        }
        while (nextUrl) consume(await fetchPage(nextUrl), false);
        if (processed !== totalCandidates || seenCandidates.size !== totalCandidates) throw inconsistent('Candidate count mismatch');
        for (var task of variantTasks.values()) { if (!task.complete) await loadVariants(task); }
        complete = true; fillTypes(); fieldset.disabled = false; apply();
        if (win.EnigmaContentFeedback) win.EnigmaContentFeedback.finish(message, function () { notice.hidden = true; });
        else notice.hidden = true;
      } catch (error) {
        if (win.EnigmaContentFeedback) win.EnigmaContentFeedback.cancel(message);
        lastError = error.message;
        message.textContent = copy.error; notice.hidden = false; retry.hidden = false;
        // A stale pagination chain must restart; network failures retry the pending page.
        if (error.restartCollection) { currentPage = 0; nextUrl = null; restart = true; }
      } finally { running = false; }
    }

    form.hidden = false;
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    var inputTimer;
    form.addEventListener('input', function (event) { if (event.target.tagName !== 'INPUT') return; win.clearTimeout(inputTimer); inputTimer = win.setTimeout(updateFilters, 180); });
    function updateFilters() {
      if (!complete) return;
      Object.keys(DEFAULTS).forEach(function (key) { state[key] = form.elements.namedItem(key).value; });
      win.history.pushState(null, '', stateUrl(win.location.href, state)); apply();
    }
    form.addEventListener('change', updateFilters);
    form.addEventListener('reset', function (event) {
      event.preventDefault(); if (!complete) return;
      state = Object.assign({}, DEFAULTS); win.history.pushState(null, '', stateUrl(win.location.href, state)); apply();
    });
    win.addEventListener('popstate', function () { state = readState(win.location.href); if (complete) { fillTypes(); apply(); } });
    retry.addEventListener('click', function () { controller.ready = load(); });
    controller.ready = load();
    return controller;
  }

  function initialize(container) {
    container.querySelectorAll('[data-offers-page]').forEach(function (root) {
      if (!root.enigmaOffersController) root.enigmaOffersController = createController(root, scope);
    });
  }
  var api = { readState: readState, stateUrl: stateUrl, matches: matches, ordered: ordered, createController: createController };
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (scope.document) {
    scope.EnigmaOffersPage = api;
    if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', function () { initialize(scope.document); });
    else initialize(scope.document);
    scope.document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
